// ============================================
// pages/Birthday.tsx
// 论坛首次发布前补填生日(年+月). 信任自报.
//   成年(≥14) → 直接放行,跳 publish
//   未成年(<14) → 跳家长授权页
// ============================================

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Cake } from 'lucide-react';
import Layout from '../components/Layout';
import { callApi } from '../services/api';

const CUR_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 80 }, (_, i) => CUR_YEAR - i);
const MONTHS = Array.from({ length: 12 }, (_, i) => i + 1);

export default function Birthday() {
  const navigate = useNavigate();
  const [year, setYear] = useState<number | ''>('');
  const [month, setMonth] = useState<number | ''>('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!year || !month) { setError('请选择出生年份和月份'); return; }
    setSubmitting(true);
    setError('');
    const res = await callApi<{ state: string; publish_enabled: boolean; age_band: string }>(
      'community-submit-birthday',
      { birth_year: year, birth_month: month },
    );
    setSubmitting(false);
    if (!res.ok) { setError(res.message || res.error || '提交失败'); return; }

    if (res.state === 'ok') {
      navigate('/publish', { replace: true });
    } else {
      navigate('/guardian', { replace: true });
    }
  };

  return (
    <Layout width="narrow" showSearch={false}>
      <div className="py-16 flex justify-center">
        <div className="bg-white border border-ink-300/40 rounded-3xl shadow-card p-8 max-w-md w-full">
          <div className="flex justify-center mb-4">
            <span className="grid place-items-center w-14 h-14 rounded-2xl bg-gold-100 text-gold-600">
              <Cake className="w-7 h-7" strokeWidth={1.5} />
            </span>
          </div>
          <h2 className="text-xl font-bold text-ink-900 text-center mb-2">填写你的出生年月</h2>
          <p className="text-ink-500 text-sm text-center leading-relaxed mb-6 text-left">
            首次发布作品需要确认你的年龄。我们只用它判断是否需要家长同意,不会公开,也不做实名。
          </p>

          <div className="flex gap-3 mb-2">
            <select
              value={year}
              onChange={(e) => setYear(e.target.value ? Number(e.target.value) : '')}
              className="flex-1 px-3 py-2.5 border border-ink-300/60 rounded-xl text-sm bg-white"
            >
              <option value="">出生年份</option>
              {YEARS.map((y) => <option key={y} value={y}>{y} 年</option>)}
            </select>
            <select
              value={month}
              onChange={(e) => setMonth(e.target.value ? Number(e.target.value) : '')}
              className="flex-1 px-3 py-2.5 border border-ink-300/60 rounded-xl text-sm bg-white"
            >
              <option value="">出生月份</option>
              {MONTHS.map((m) => <option key={m} value={m}>{m} 月</option>)}
            </select>
          </div>

          {error && <p className="text-sm text-red-600 mb-3">{error}</p>}

          <button
            onClick={submit}
            disabled={submitting}
            className="btn-primary w-full mt-4"
          >
            {submitting ? '提交中…' : '确认'}
          </button>
        </div>
      </div>
    </Layout>
  );
}
